export const ChatHistoryType = {
  FETCH_CHAT_HISTORY_REQUEST: 'FETCH_CHAT_HISTORY_REQUEST',
  FETCH_CHAT_HISTORY_SUCCESS: 'FETCH_CHAT_HISTORY_SUCCESS',
  FETCH_CHAT_HISTORY_FAILURE: 'FETCH_CHAT_HISTORY_FAILURE',
}
